import Services from '../Service'

class VendedorService extends Services {
  constructor() {
    super()
    this.resource = 'vendedores'
  }

  async getVendedores(params) {
    return await this.getAPI(this.resource, params)
  }
}

export default new VendedorService()
